import { storeToRefs } from 'pinia'
import type { AccessToken } from '@/models/api/access-token'
import type LoginApi from '@/services/apis/login-api'
import { useUserStore } from '@/stores/use-user-store'
import { isApiSuccess } from '~library/utils/functions'

/** 使用 refresh token 重新取得存取權杖 */
export function useRefreshToken(api: LoginApi) {
  const { userProfile } = storeToRefs(useUserStore())

  /** 使用 refresh token 重新取得存取權杖 */
  async function refreshToken(): Promise<AccessToken | null> {
    if (!userProfile.value?.refreshToken) {
      return null
    }

    const responseData = (
      await api.refreshToken({
        refreshToken: userProfile.value.refreshToken
      })
    ).data

    return isApiSuccess(responseData) ? responseData.data : null
  }

  return {
    /** 使用 refresh token 重新取得存取權杖 */
    refreshToken
  }
}
